import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon, LockIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { PlaygroundVisual } from './PlaygroundVisual';
import { sideProjects } from '../../data/writing';
const LINK_CLASS = 'group block rounded-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 focus-visible:ring-offset-4 focus-visible:ring-offset-canvas';
export function Playground() {
  return <section id="playground" className="mt-28 scroll-mt-24 lg:scroll-mt-10" data-id="element-300" data-mp="jkhzy8p69729">
      <SectionHeading index="03" label="Playground" title="Side projects & experiments" data-id="element-301" data-mp="noppg83ger1j" />
      <div className="mt-8 grid gap-x-6 gap-y-10 md:grid-cols-2" data-id="element-302" data-mp="smzh48pyz9ie">
        {sideProjects.map((project, i) => {
        const href = 'href' in project ? project.href : undefined;
        const external = 'external' in project ? project.external : undefined;
        const linkLabel = 'linkLabel' in project ? project.linkLabel : undefined;
        const locked = 'locked' in project && project.locked;
        const interactive = Boolean(href || external);
        const body = <>
              <div className="relative aspect-[4/3] overflow-hidden rounded-2xl" data-id="element-303" data-mp="2ezxf3g88vitt">
                <div className={`absolute inset-0 ${interactive ? 'transition-transform duration-200 ease-out group-hover:scale-[1.015]' : ''}`} data-id="element-304" data-mp="2a0u99tkfx8ks">
                  {'image' in project && project.image ? <img src={project.image.src} alt={project.image.alt} className={`h-full w-full object-cover ${project.image.mono ? 'object-[center_30%] grayscale' : 'object-center'}`} data-id="element-305" data-mp="32pi1k93lwy7u" /> : <PlaygroundVisual visual={project.visual} data-id="element-306" data-mp="1hau9g94sqlos" />}
                </div>
                {locked && <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-coral px-2.5 py-1 text-[11px] font-semibold text-white" data-id="element-307" data-mp="1it2e7sq50els">
                    <LockIcon className="h-3 w-3" aria-hidden data-id="element-308" data-mp="19se253kb0obj" />
                    Password
                  </span>}
              </div>
              <h3 className={`mt-4 text-[15px] font-semibold text-fg ${interactive ? 'transition-colors duration-150 group-hover:text-ink' : ''}`} data-id="element-309" data-mp="1et224eqigfhw">
                {project.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-fg-muted" data-id="element-310" data-mp="r1mv48nsha0b">{project.description}</p>
              {interactive && linkLabel && <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-ink" data-id="element-311" data-mp="v3rkgv77fkh5">
                  {linkLabel}
                  {external ? <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-312" data-mp="m2tfoaoxz8xi" /> : <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-313" data-mp="3tn1dddgsd3g3" />}
                </span>}
            </>;
        return <Reveal key={project.title} delay={i * 0.05} data-id="element-314" data-mp="7ejmsmk43iuu" data-mpi={i}>
              {href ? <Link to={href} className={LINK_CLASS} data-id="element-315" data-mp="lekou5c44wbw">
                  {body}
                </Link> : external ? <a href={external} {...external.startsWith('mailto:') ? {} : {
            target: '_blank',
            rel: 'noreferrer'
          }} className={LINK_CLASS} data-id="element-316" data-mp="gfq613e5b7rs">
                  {body}
                </a> : <article data-id="element-317" data-mp="146vm9jo0022m">{body}</article>}
            </Reveal>;
      })}
      </div>
    </section>;
}